
import axios from "axios";
    export default  {

        data(){
        
            return{
                tableData:[],
                pageSize:10000,
                pageNum:1,
                reason:'',
                dialogVisible: false,
                settleType:1,
                rules: {
                    name: [
                    { required: true, message: '请输入拒绝原因', trigger: 'blur' }
                    ]
                },
                deliveryVisible: false,
                expressName:'',
                expressCode:'',
                orderCode:'',
                expressList:[]
            }
        },
        mounted() {
            
            this.axios.get('http://localhost:9000/express.json').then(response => {

                this.expressList = response.data.data;
                // console.log('快递------',this.expressList);
            });
            this.getOrderList(1);
        },
        methods:{

            subtract(a:any, b:any) {

                return a - b;
            },
            getOrderList(num:any){
	  	  
                let datas = [];
                this.pageNo = num;
                let paramter = {
                    'pageNum':this.pageNo,
                    'pageSize':this.pageSize
                };
                this.$http.get("product/order/list", {params:paramter}).then((res: any) => {
                    this.totalNum = res.data.data.total;
                    datas = res.data.data.data;
                    this.pageNo = num;
                    this.pageSize = res.data.data.pageSize;
                    this.tableData = datas;
                    this.tableData = this.tableData.map(item=>{
                        // item.enable = item.enable == 1?true:false;
                        item.tasteCount = res.data.data.total;
                        return item;
                    });
                    
                });
            },
            handleLookAll(index,row){

                // 查看全部商品及规格
                console.log(row);
                this.$router.push({path: '/MyStore/commonOrderDetail',query:{orderCode:row.productOrderCode}})
            },
            handleDelProduct(index,row){
                // 删除订单
                console.log('\\\\',row);
                /*
                let ptCodeList = [];
                ptCodeList.push(row.ptCode);

                this.$http.delete("product",ptCodeList).then((res: any) =>{
          
                    this.$confirm('删除成功');
                    this.dialogVisible = false;
                    window.location.reload();
                });
                */
            },
            handlePrintProduct(index:any,row:any){
                // 打印订单
                console.log('\\\\',row);
            },
            handleRefund(index:any,row:any){
                // 审核退款
                this.dialogVisible = false;
                let orderCode = row.productOrderCode;
                let paramter = {
                    'productOrderCode':orderCode,
                    'approveTag':1,
                    'approveReason':''
                };
                this.$http.post("product/order/approve/refund",paramter).then((res: any) =>{
          
                    this.$confirm('审核成功');
                    this.dialogVisible = false;
                    window.location.reload();
                });

            },
            handleNoRefund(index:any,row:any) {

                // 拒绝退款
                this.dialogVisible = true;
            },
            sureSubmit(index:any) {
                // 拒绝退款提交原因
                this.dialogVisible = false;
                console.log(index);
            },
            handleClose(){

                // 审核原因弹框关闭
                this.dialogVisible = false;
                this.deliveryVisible = false;
            },
            handleDelivery(index:any,row:any) {

                // 发货
                console.log(row);
                this.deliveryVisible = true;
                this.orderCode = row.productOrderCode;
            },
            sureDeliverySubmit(){

                // 433967064302734 韵达快递
                let expressId = '';
                console.log('快递',this.expressName);
                this.expressList.map(item=>{
                    if(item.name == this.expressName) {

                        expressId = item.code;
                    }
                });

                let paramter = {
                    'productOrderCode':this.orderCode,
                    'expressCode':this.expressCode,
                    'expressName':this.expressName,
                    'expressId' : expressId
                };
                this.$http.post("product/order/send",paramter).then((res: any) =>{
          
                    this.$confirm('发货成功');
                    this.deliveryVisible = false;
                    window.location.reload();
                });
                
            },
            handleTakeOrder(index:any,row:any) {

                // 用户已支付，确认接单
                let paramter = {
                    'productOrderCode':row.productOrderCode
                };
                this.$http.post("product/order/ack",paramter).then((res: any) =>{
          
                    this.$confirm('接单成功');
                    window.location.reload();
                });
            }
        }
    }
